// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"styles-module--testimonials--1buGC","testimonialsContainer":"styles-module--testimonialsContainer--2u7RI","quote":"styles-module--quote--3aiKq"};